import { OneEyeService } from './api'


const krtiWebUrl = process.env.REACT_APP_WEB_BASE_URL;


export const getLocation = async () => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/Location`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const CreateCategory = async (req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/category/add-update-category
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const CategoryStatusupdate = async (req) => {
    // const {i} = payload
    try {
        return await OneEyeService.post(`${krtiWebUrl}/category/statusUpdate/${req?.id}/${req?.status}/
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}


export const GetMerchantCategory = async (selectedMerchant) => {

    try {
        return await OneEyeService.get(`${krtiWebUrl}/category/getmerchantCategory/${selectedMerchant}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}